import React from 'react';
import { StoreContext } from './StoreDropdown';

export default function GetAppButton() {
  const goToStore = (url) => {
    window.location.assign(url);
  }
  return (
    <StoreContext.Consumer> 
      {({value, url}) => (
        (value.length) > 0 &&
          <button onClick={() => goToStore(url)} className={`get-app-btn ${value.length > 0 ? 'active' : ''}`} >
            Get the app
          </button>
      )}
    </StoreContext.Consumer>
  )
}
